export const TOOL_ID_XCEED = 'xceed';

export const XCEED_PRODUCT = {
  providedToolId: TOOL_ID_XCEED,
  name: 'Xceed',
  phase2Title: 'Connect Xceed to the platform',
  registerButtonLabel: 'Register Xceed',
} as const;

export function isXceedTool(providedToolId: string): boolean {
  return providedToolId === TOOL_ID_XCEED;
}

export function findXceedTool<T extends { providedToolId: string }>(
  tools: T[]
): T | null {
  return tools.find((tool) => isXceedTool(tool.providedToolId)) ?? null;
}
